Object.defineProperty(exports,"__esModule",{value:true});var _omit2=require("lodash/omit");var _omit3=_interopRequireDefault(_omit2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);
var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

{

getBarWidth:function getBarWidth(props){var
style=props.style,width=props.width,data=props.data;
var padding=props.padding.left||props.padding;
var defaultWidth=data.length===0?8:(width-2*padding)/data.length;
return style&&style.width?style.width:defaultWidth;
},

getBarPosition:function getBarPosition(props,datum,scale){
var defaultMin=_victoryCore.Scale.getType(scale.y)==="log"?
1/Number.MAX_SAFE_INTEGER:0;

var y0=datum._y0!==undefined?datum._y0:defaultMin;
var formatValue=function formatValue(value,axis){
return datum[axis]instanceof Date?new Date(value):value;
};
var x=datum._x1!==undefined?datum._x1:datum._x;
var y1=datum._y1!==undefined?datum._y1:datum._y;
return{
x:scale.x(formatValue(x,"x")),
y0:scale.y(formatValue(y0,"y")),
y:scale.y(formatValue(y1,"y"))};

},

getBarStyle:function getBarStyle(datum,baseStyle){
var styleData=(0,_omit3.default)(datum,[
"xName","yName","x","y","label","errorX","errorY","eventKey"]);

return(0,_defaults3.default)({},styleData,baseStyle);
},

getLabelStyle:function getLabelStyle(style,datum){
return(0,_defaults3.default)({},{
angle:datum.angle,
textAnchor:datum.textAnchor,
verticalAnchor:datum.verticalAnchor},
style);
},

getLabel:function getLabel(props,datum,index){
return datum.label||(Array.isArray(props.labels)?
props.labels[index]:props.labels);
},

getLabelAnchors:function getLabelAnchors(datum,horizontal){
var sign=datum._y>=0?1:-1;
if(!horizontal){
return{
vertical:sign>=0?"end":"start",
text:"middle"};

}else{
return{
vertical:"middle",
text:sign>=0?"start":"end"};

}
},

getlabelPadding:function getlabelPadding(style,datum,horizontal){
var defaultPadding=style.padding||0;
var sign=datum._y<0?-1:1;
return{
x:horizontal?sign*defaultPadding:0,
y:horizontal?0:sign*defaultPadding};

},

getCalculatedValues:function getCalculatedValues(props){var
theme=props.theme,horizontal=props.horizontal;
var defaultStyles=theme&&theme.bar&&theme.bar.style?theme.bar.style:{};
var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%");
var data=_victoryCore.Data.getData(props);
var range={
x:_victoryCore.Helpers.getRange(props,"x"),
y:_victoryCore.Helpers.getRange(props,"y")};

var domain={
x:_victoryCore.Domain.getDomainWithZero(props,"x"),
y:_victoryCore.Domain.getDomainWithZero(props,"y")};

var xScale=_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x);
var yScale=_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y);
var scale={
x:horizontal?yScale:xScale,
y:horizontal?xScale:yScale};

return{style:style,data:data,scale:scale,domain:domain};
},

getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"bar");var _getCalculatedValues=
this.getCalculatedValues(props),style=_getCalculatedValues.style,data=_getCalculatedValues.data,scale=_getCalculatedValues.scale,domain=_getCalculatedValues.domain;var _props=
props,horizontal=_props.horizontal,width=_props.width,height=_props.height,padding=_props.padding,standalone=_props.standalone,theme=_props.theme;
var initialChildProps={parent:{
domain:domain,scale:scale,width:width,height:height,data:data,standalone:standalone,theme:theme,style:style.parent}};


return data.reduce(function(childProps,datum,index){
var eventKey=datum.eventKey||index;
var position=_this.getBarPosition(props,datum,scale);
var dataProps=(0,_assign3.default)(
{
style:_this.getBarStyle(datum,style.data),
index:index,
datum:datum,
scale:scale,
horizontal:horizontal,
padding:padding,
width:width,
data:data},

position);


childProps[eventKey]={
data:dataProps};

var text=_this.getLabel(props,datum,index);
if(text!==undefined&&text!==null||props.events||props.sharedEvents){
childProps[eventKey].labels=_this.getLabelProps(dataProps,text,style);
}

return childProps;
},initialChildProps);
},

getLabelProps:function getLabelProps(dataProps,text,calculatedStyle){var
datum=dataProps.datum,data=dataProps.data,horizontal=dataProps.horizontal,x=dataProps.x,y=dataProps.y,y0=dataProps.y0,index=dataProps.index,scale=dataProps.scale;
var labelStyle=this.getLabelStyle(calculatedStyle.labels,datum);
var labelPadding=this.getlabelPadding(labelStyle,datum,horizontal);
var anchors=this.getLabelAnchors(datum,horizontal);
return{
style:labelStyle,
x:horizontal?y+labelPadding.x:x+labelPadding.x,
y:horizontal?x+labelPadding.y:y-labelPadding.y,
y0:y0,
text:text,
index:index,
scale:scale,
datum:datum,
data:data,
horizontal:horizontal,
textAnchor:labelStyle.textAnchor||anchors.text,
verticalAnchor:labelStyle.verticalAnchor||anchors.vertical,
angle:labelStyle.angle};

}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/victory-bar/helper-methods.js
// module id = 1445
// module chunks = 0